<template>
    <v-dialog
            v-model="display"
            lazy
            full-width
            :width="width"
            :disabled="disabled">


        <v-text-field v-if="box"
                      slot="activator"
                      :label="label"
                      :value="formattedDatetime"
                      :disabled="disabled"
                      readonly
                      box
                      prepend-icon='fas fa-calendar'
        >
        </v-text-field>
        <v-text-field v-else
                      slot="activator"
                      :label="label"
                      :value="formattedDatetime"
                      :disabled="disabled"
                      readonly
                      prepend-icon='fas fa-calendar'
        >
        </v-text-field>

        <v-card>
            <v-card-text style="padding: 0;">
                <v-tabs slider-color="primary" fixed-tabs v-model="activeTab">
                    <v-tab v-if="!dateOnly" key="calendar">
                        <v-icon>event</v-icon>
                    </v-tab>
                    <v-tab v-if="!dateOnly" key="timer" :disabled="!dateSelected">
                        <v-icon>access_time</v-icon>
                    </v-tab>
                    <v-tab-item key="calendar">
                        <v-date-picker
                                full-width
                                header-color="secondary"
                                color="primary"
                                v-model="datePart"
                                scrollable
                                :locale="locale"
                                actions
                                :landscape="landscape">
                        </v-date-picker>
                    </v-tab-item>
                    <v-tab-item v-if="!dateOnly" key="timer">
                        <v-time-picker
                                ref="timer"
                                full-width
                                class="v-time-picker-custom"
                                header-color="secondary"
                                color="primary"
                                v-model="timePart"
                                scrollable
                                :format="timePickerFormat"
                                actions
                                :landscape="landscape">
                        </v-time-picker>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey lighten-1" flat @click.native="clearHandler">{{clearText}}</v-btn>
                <v-btn color="secondary darken-1" flat @click="okHandler">{{okText}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import moment from 'moment'

    const DEFAULT_MYSQL_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
    const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'
    const DEFAULT_TIME_FORMAT = 'HH:mm'
    const DEFAULT_TIME = '00:00'

    export default {
      name: 'v-datetime-picker',
      model: {
        prop: 'datetime',
        event: 'input'
      },
      props: {
        datetime: {
          type: [Date, String],
          default: null
        },
        label: {
          type: String,
          default: ''
        },
        width: {
          type: Number,
          default: 320
        },
        format: {
          type: String,
          default: 'YYYY-MM-DD HH:mm:ss'
        },
        timePickerFormat: {
          type: String,
          default: '24hr'
        },
        locale: {
          type: String,
          default: 'en-us'
        },
        clearText: {
          type: String,
          default: 'CLEAR'
        },
        okText: {
          type: String,
          default: 'OK'
        },
        disabled: {
          type: Boolean,
          default: false
        },
        landscape: {
          type: Boolean,
          default: false
        },
        mysql: {
          type: Boolean,
          default: false
        },
        dateOnly: {
          type: Boolean,
          default: false
        },
        box: {
          type: Boolean,
          default: false
        }
      },
      data () {
        return {
          display: false,
          dateSelected: false,
          timeSelected: false,
          activeTab: 0,
          selectedDatetime: null
        }
      },
      created () {
        if (this.datetime instanceof Date) {
          this.selectedDatetime = this.datetime
        } else if (this.datetime instanceof String) {
          this.selectedDatetime = moment(this.datetimeString, this.format)
        }
      },
      computed: {
        datePart: {
          get () {
            let val = this.selectedDatetime ? moment(this.selectedDatetime).format(DEFAULT_DATE_FORMAT) : ''
            return val
          },
          set (val) {
            this.dateSelected = true
            this.activeTab = 1

            if (this.dateOnly) {
              let date = moment(val, DEFAULT_DATE_FORMAT)
              let input = moment().year(date.year()).month(date.month()).date(date.date())
              this.selectedDatetime = input.toDate()

              this.okHandler()
            } else {
              let date = moment(val, DEFAULT_DATE_FORMAT)
              let hour = this.selectedDatetime ? moment(this.selectedDatetime).hour() : 0
              let minute = this.selectedDatetime ? moment(this.selectedDatetime).minute() : 0
              let input = moment().year(date.year()).month(date.month()).date(date.date()).hour(hour).minute(minute).second(0)
              this.selectedDatetime = input.toDate()
            }
          }
        },
        timePart: {
          get () {
            let val = this.selectedDatetime ? moment(this.selectedDatetime).format(DEFAULT_TIME_FORMAT) : DEFAULT_TIME
            return val
          },
          set (val) {
            this.timeSelected = true

            let time = moment(val, DEFAULT_TIME_FORMAT)
            let input = moment(this.selectedDatetime).hour(time.hour()).minute(time.minute()).second(0)
            this.selectedDatetime = input.toDate()
          }
        },
        formattedDatetime () {
          return this.datetime ? moment(this.datetime).format(this.format) : ''
        }
      },
      methods: {
        okHandler () {
          this.display = false
          this.activeTab = 0

          if (!this.dateOnly) {
            this.$refs.timer.selectingHour = true
          }

          if (this.mysql) {
            if (this.dateOnly) {
              this.$emit('input', moment(this.selectedDatetime).format(DEFAULT_DATE_FORMAT))
            } else {
              this.$emit('input', moment(this.selectedDatetime).format(DEFAULT_MYSQL_DATETIME_FORMAT))
            }
          } else {
            if (this.dateOnly) {
              this.$emit('input', moment(this.selectedDatetime).format(DEFAULT_DATE_FORMAT))
            } else {
              this.$emit('input', this.selectedDatetime)
            }
          }
        },
        clearHandler () {
          this.display = false
          this.activeTab = 0

          if (!this.dateOnly) {
            this.$refs.timer.selectingHour = true
          }

          this.$emit('input', null)
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/Shared/DatetimePicker.vue